<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>
          {{
            tipoComprobante === codigoFactura
              ? "Comprobante de compra"
              : "Nota de crédito"
          }}
        </h3>
        <label>
          <div v-show="anulado === 'S'" class="noti-danger">
            <strong>ANULADO</strong>
          </div>
          <div
            v-show="form.cabecera.estado === 'A' && anulado === 'N'"
            class="noti-success"
          >
            <strong>AUTORIZADO</strong>
          </div>
          <div
            v-show="form.cabecera.estado === 'N' && anulado === 'N'"
            class="noti-secondary"
          >
            <strong>NUEVO</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <form @submit="submitFoto" :action="url + '/subir-comprobante-compra/' + id_comprobante" method="POST" enctype="multipart/form-data" class="form-inline">
          <input v-show="form.cabecera.estado !== 'N' && anulado !== 'S'" type="file" name="path_foto" id="path_foto">
          <input type="hidden" name="_token" :value="token" />
          <button v-show="form.cabecera.estado !== 'N' && anulado !== 'S'" type="submit" class="btn-success btn--bigger">
            <i class="fa fa-upload"></i><span>Subir documento(s)</span>
          </button>
          <button @click="descargarArchivo" v-show="form.cabecera.estado !== 'N' && path_foto != '' && path_foto != null" type="button" class="btn-info btn--bigger">
            <i class="fa fa-download"></i><span>Ver documento(s)</span>
          </button>
          <button
              :disabled="!permiteEditarComprobante && !permiteAnularComprobante"
              class="btn-bus200 btn--bigger"
              @click="buscarComprobante"
              type="button"
            >
              <i class="fa fa-search"></i> <span>Consultar</span>
          </button>
        </form>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <cabecera-compra
          @decimalesActualizados="decimalesActualizados"
          @consultarAfectado="consultarAfectado"
          @consultar="consultar"
          @quitarComprobante="quitarComprobante"
          :codigoFactura="codigoFactura"
          :codigoNotaCredito="codigoNotaCredito"
          :disabled="!editable"
          :errores="errores"
          :monedas="monedas"
          v-model="form.cabecera"
          :tipoComprobante="tipoComprobante"
        >
        </cabecera-compra>
        <div class="card">
          <div class="card__title">
            <div class="form-inline">
              <input-field
                id="searchItems"
                v-model="searchItems"
                placeholder="Consulta de detalle por descripción..."
              ></input-field>
              <h5>Detalles del comprobante</h5>
            </div>
          </div>
          <div class="card__content">
            <tabla-detalle-comprobante
              :decimales_compras="decimales_compras"
              tipo="P"
              :disabled="!editable"
              @input="inputDetalles"
              :errores="errores"
              :anulado="anulado"
              :irbpnr="irbpnr"
              v-model="form.items"
              :tipoComprobante="tipoComprobante"
              :search="searchItems"
            ></tabla-detalle-comprobante>
          </div>
        </div>
        <div v-show="tipoComprobante === codigoFactura" class="card">
          <div class="card__title">
            <h5>Formas de pago</h5>
          </div>
          <div class="card__content">
            <tabla-forma-pago
              :disabled="!editable"
              v-model="form.formasPago"
              :tiposUnidad="tiposUnidad"
              :totalComprobante="form.total"
              :errores="errores"
              :formasPago="formasPago"
            ></tabla-forma-pago>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-xs-12 col-md-7">
            <div class="card">
              <div class="card__title">
                <h5>Información adicional</h5>
              </div>
              <div class="card__content">
                <tabla-informacion-adicional
                  :errores="errores"
                  v-model="form.informacionAdicional"
                ></tabla-informacion-adicional>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-5">
            <div class="card">
              <div class="card__title">
                <h5>Totales del comprobante</h5>
              </div>
              <div class="card__content">
                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.total_sin_impuestos"
                        id="subtotal_sin_impuestos"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Subtotal S/I</span>
                        <span
                          v-if="errores.total_sin_impuestos"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.total_sin_impuestos[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.descuento_total"
                        id="descuento_total"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Descuento total</span>
                        <span
                          v-if="errores.descuento_total"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.descuento_total[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_no_sujeto_iva"
                        id="subtotal_no_iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Subtotal N/IVA</span>
                        <span
                          v-if="errores.subtotal_no_sujeto_iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.subtotal_no_sujeto_iva[0]
                          }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_exento_iva"
                        id="subtotal_e_iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Subtotal E/I</span>
                        <span
                          v-if="errores.subtotal_exento_iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_exento_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.total_irbpnr"
                        id="total_irbpnr"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Total IRBPNR</span>
                        <span
                          v-if="errores.total_irbpnr"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.total_irbpnr[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_iva"
                        id="subtotal_iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Subtotal IVA</span>
                        <span
                          v-if="errores.subtotal_iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_iva_0"
                        id="subtotal_iva_0"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Subtotal IVA 0%</span>
                        <span
                          v-if="errores.subtotal_iva_0"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_iva_0[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.iva"
                        id="iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>IVA</span>
                        <span
                          v-if="errores.iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.ice"
                        id="ice"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>ICE</span>
                        <span
                          v-if="errores.ice"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.ice[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.total"
                        id="total"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        <span>Total</span>
                        <span
                          v-if="errores.total"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.total[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              v-show="anulado !== 'S'"
              :disabled="
                !permiteCrearComprobante ||
                !permiteEditarComprobante ||
                anulado === 'S'
              "
              @click="guardarComprobanteCompra"
              class="btn-success"
            >
              <i class="fa fa-save"></i> <span>Guardar</span>
            </button>
            <button
              :disabled="!permiteCrearComprobante"
              @click="nuevoComprobante"
              type="button"
              class="btn-light btn--text"
            >
              <i class="fa fa-plus"></i> <span>Nuevo</span>
            </button>
            <button
              :disabled="!permiteAnularComprobante"
              @click="anularComprobante"
              v-show="form.cabecera.estado !== 'N' && anulado === 'N'"
              type="button"
              class="btn-danger btn--text"
            >
              <i class="fa fa-ban"></i> <span>Anular</span>
            </button>
            <button
              @click="imprimirComprobante"
              v-show="form.cabecera.estado !== 'N'"
              type="button"
              class="btn-success btn--text"
            >
              <i class="fa fa-print"></i> <span>Imprimir</span>
            </button>
            <button
              @click="mostrarAbonos"
              v-show="form.cabecera.estado !== 'N'"
              type="button"
              class="btn-info btn--text"
            >
              <i class="fa fa-money"></i> <span>Abonos</span>
            </button>
            <button @click="verAnterior" type="button" class="btn-bus300 btn--text">
              <i class="fa fa-toggle-left"></i>Anterior
            </button>
            <button @click="verSiguiente" type="button" class="btn-bus300 btn--text">
              <i class="fa fa-toggle-right"></i>Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal width="70%" name="coincidenciaComprobantes" height="auto" scrollable>
      <coincidencia-comprobantes
        @seleccionar="seleccionarComprobanteAfectado"
        @cerrar="$modal.hide('coincidenciaComprobantes')"
        :comprobantes="comprobantesConsultados"
      ></coincidencia-comprobantes>
    </modal>
    <modal adaptive resizable reset name="comprobantes" height="auto" width="80%" scrollable>
      <lista-comprobantes-compra
        @selected="selectedComprobante"
        :tipoComprobante="tipoComprobanteConsulta"
      ></lista-comprobantes-compra>
    </modal>
    <modal adaptive resizable reset name="abonosCompra" height="auto" width="80%" scrollable>
      <abonos-compra :idComprobante="id_comprobante"></abonos-compra>
    </modal>
  </div>
</template>

<script>
import AbonosCompra from './AbonosCompra';
export default {
  components: {
    AbonosCompra
  },
  props: {
    token: {
      type: String,
      required: false,
      default: ''
    },
    tipoComprobante: {
      type: String,
      required: true,
    },
    comprobante: {
      type: Object,
      required: false,
      default: function () {
        return null;
      },
    },
    permiteCrearCompra: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteEditarCompra: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteAnularCompra: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteCrearNc: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteEditarNc: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteAnularNc: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      decimales_compras: 2,
      path_foto: '',
      money: money,
      form: {
        cabecera: {
          clave_acceso: "",
          numero_autorizacion: "",
          numero_documento: "",
          fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
          id_proveedor: "",
          id_moneda: "",
          fecha_autorizacion: "",
          mybillbot: false,
          tipo_documento: "",
          tipo: "E",
          numero_identificacion: "",
          estado: "N",
          tipo_comprobante: this.tipoComprobante,
          tipo_comprobante_afectado: "",
          numero_comprobante_afectado: "",
          fecha_emision_comprobante_afectado: "",
        },
        items: [],
        formasPago: [],
        informacionAdicional: [],
        total_sin_impuestos: 0,
        descuento_total: 0,
        subtotal_no_sujeto_iva: 0,
        subtotal_exento_iva: 0,
        total_irbpnr: 0,
        iva: 0,
        subtotal_iva: 0,
        subtotal_iva_0: 0,
        ice: 0,
        total: 0,
        _method: undefined,
      },
      id_comprobante: "",
      errores: {},
      url: url,
      irbpnr: 0,
      monedas: [],
      codigoIva: "",
      codigoIce: "",
      codigoFactura: "",
      codigoNotaCredito: "",
      ivaNoObjeto: "",
      ivaExento: "",
      ivaCero: "",
      ivaActual: "",
      formasPago: [],
      anulado: "N",
      tiposUnidad: [],
      tipoComprobanteConsulta: this.tipoComprobante,
      comprobantesConsultados: [],
      searchItems: "",
    };
  },
  methods: {
    decimalesActualizados: function (decimales_compras) {
      this.decimales_compras = decimales_compras;
    },
    verAnterior: function () {
      let urlRequest = url + '/siguiente-compra/A?tipo_comprobante=' + this.tipoComprobante + '&id_comprobante=' + this.id_comprobante;
      axios.get(urlRequest).then(({data}) => {
        if (data.idComprobante != null) {
          location.href = url + '/compras/' + data.idComprobante + '/edit';
        }
        else 
          swal('No hay documento disponible.', 'Aviso', 'warning');
      });
    },
    verSiguiente: function () {
      let urlRequest = url + '/siguiente-compra/S?tipo_comprobante=' + this.tipoComprobante + '&id_comprobante=' + this.id_comprobante;
      axios.get(urlRequest).then(({data}) => {
        if (data.idComprobante != null) {
          location.href = url + '/compras/' + data.idComprobante + '/edit';
        }
        else 
          swal('No hay documento disponible.', 'Aviso', 'warning');
      });
    },
    mostrarAbonos: function () {
      this.$modal.show('abonosCompra');
    },
    descargarArchivo: function () {
      window.open(this.path_foto, '_blank');
    },
    submitFoto: function (event) {
      if (document.getElementById("path_foto").files.length === 0) {
        event.preventDefault();
        swal('Debe seleccionar un documento.', 'Aviso', 'warning');
      }
    },
    imprimirComprobante: function () {
      window.open(
        this.url + "/compras/" + this.id_comprobante + "/ride",
        "_blank"
      );
    },
    quitarComprobanteAfectado: function () {
      this.form.cabecera.tipo_comprobante_afectado = "";
      this.form.cabecera.numero_comprobante_afectado = "";
      this.form.cabecera.fecha_emision_comprobante_afectado = "";
    },
    seleccionarComprobanteAfectado: function (comprobante) {
      this.tipoComprobanteConsulta = this.codigoFactura;
      this.selectedComprobante(comprobante);
      this.$modal.hide("coincidenciaComprobantes");
    },
    consultarAfectado: function () {
      this.tipoComprobanteConsulta = this.codigoFactura;
      if (this.form.cabecera.numero_comprobante_afectado !== "") {
        let that = this;
        axios
          .get(
            this.url +
              "/compras/" +
              this.form.cabecera.numero_comprobante_afectado,
            {
              params: {
                tipoComprobanteAfectado: this.tipoComprobanteConsulta,
              },
            }
          )
          .then(function (response) {
            if (response.data.length > 0) {
              if (response.data.length === 1)
                that.selectedComprobante(response.data[0]);
              else {
                that.comprobantesConsultados = response.data;
                that.$modal.show("coincidenciaComprobantes");
              }
            } else {
              that.quitarComprobanteAfectado();
              swal(
                "No se encontró comprobantes con el número proporcionado.",
                "Mensaje",
                "warning"
              );
            }
          });
      } else
        swal("Debe ingresar un número de comprobante.", "Aviso", "warning");
    },
    consultar: function () {
      this.tipoComprobanteConsulta = this.codigoFactura;
      this.$modal.show("comprobantes");
    },
    quitarComprobante: function () {
      this.form.items = [];
      this.calcularTotales();
    },
    buscarComprobante: function () {
      this.tipoComprobanteConsulta = this.tipoComprobante;
      this.$modal.show("comprobantes");
    },
    guardarComprobanteCompra: function () {
      let that = this;
      let requestUrl = that.url + "/compras";
      this.errores = {};
      if (this.form.cabecera.estado !== "N") {
        requestUrl += "/" + this.id_comprobante;
        this.form._method = "PUT";
      } else this.form._method = undefined;
      axios
        .post(requestUrl, this.form)
        .then(function (response) {
          that.form.cabecera.estado = "A";
          that.id_comprobante = response.data.id_comprobante;
          swal(
            "El formulario fue almacenado con éxito.",
            "Realizado",
            "success"
          );
        })
        .catch(function (error) {
          if (error !== undefined && error !== undefined) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) {
                that.errores = response.data.errors;
                swal(
                  "Hay errores de validación en el formulario.",
                  "Mensaje",
                  "warning"
                );
              } else
                swal(
                  "Hubo un error al momento de almacenar el comprobante, intente nuevamente.",
                  "Error",
                  "error"
                );
            }
          }
        });
    },
    cargarDatosFormulario: function () {
      let that = this;
      axios.get(this.url + "/compras/datos").then(function (response) {
        that.irbpnr = parseFloat(response.data.irbpnr.valor_tarifa);
        that.monedas = response.data.monedas;
        that.codigoIva = response.data.codigoIva;
        that.codigoIce = response.data.codigoIce;
        that.codigoFactura = response.data.codigoFactura;
        that.codigoNotaCredito = response.data.codigoNotaCredito;
        that.ivaNoObjeto = response.data.ivaNoObjeto;
        that.ivaExento = response.data.ivaExento;
        that.ivaCero = response.data.ivaCero;
        that.ivaActual = response.data.ivaActual;
        that.formasPago = response.data.formasPago;
        that.tiposUnidad = response.data.tiposUnidad;
        that.monedas = response.data.monedas;
        if (that.comprobante !== null)
          that.selectedComprobante(that.comprobante);
      });
    },
    inputDetalles: function (detalles) {
      this.form.items = detalles;
      this.calcularTotales();
    },
    calcularTotales: function () {
      let irbpnr = 0;
      let totalSinImpuestos = 0;
      let iva = 0;
      let ice = 0;
      let descuento = 0;
      let subtotalNoIva = 0;
      let subtotalExIva = 0;
      let subtotalIva0 = 0;
      let subtotalIva = 0;
      for (let i = 0; i < this.form.items.length; i++) {
        totalSinImpuestos += this.form.items[i].total_parcial;
        iva += this.form.items[i].iva;
        ice += this.form.items[i].ice;
        irbpnr += this.form.items[i].total_irbpnr;
        let desc = parseFloat(this.form.items[i].total_descuento);
        if (!isNaN(desc)) descuento += desc;
        if (this.form.items[i].id_iva === this.ivaNoObjeto)
          subtotalNoIva += this.form.items[i].total_parcial;
        if (this.form.items[i].id_iva === this.ivaExento)
          subtotalExIva += this.form.items[i].total_parcial;
        if (this.form.items[i].id_iva === this.ivaCero)
          subtotalIva0 += this.form.items[i].total_parcial;
        if (this.form.items[i].iva > 0)
          subtotalIva += this.form.items[i].total_parcial;
      }
      this.form.subtotal_iva_0 = subtotalIva0;
      this.form.subtotal_exento_iva = subtotalExIva;
      this.form.total_sin_impuestos = totalSinImpuestos;
      this.form.iva = iva;
      this.form.ice = ice;
      this.form.total_irbpnr = irbpnr;
      this.form.descuento_total = descuento;
      this.form.subtotal_no_sujeto_iva = subtotalNoIva;
      this.form.subtotal_iva = subtotalIva;
      this.form.total =
        parseFloat(totalSinImpuestos) +
        //-
        //parseFloat(descuento) +
        parseFloat(iva) +
        parseFloat(ice) +
        parseFloat(irbpnr);
    },
    selectedComprobante: function (comprobante) {
      this.$modal.hide("comprobantes");
      this.form.items = [];
      this.form.subtotal_exento_iva = comprobante.subtotal_exento_iva;
      this.form.subtotal_iva = comprobante.subtotal_iva;
      this.form.subtotal_iva_0 = comprobante.subtotal_iva_0;
      this.form.subtotal_no_sujeto_iva = comprobante.subtotal_no_iva;
      this.form.descuento_total = comprobante.total_descuento;
      this.form.total_sin_impuestos = comprobante.total_sin_impuestos;
      this.form.ice = comprobante.valor_ice;
      this.form.iva = comprobante.valor_iva;
      this.form.total_irbpnr = comprobante.valor_irbpnr;
      this.form.total = comprobante.total;
      this.form.cabecera.id_proveedor = comprobante.id_persona;
      this.form.cabecera.nombre_proveedor = comprobante.razon_social;
      this.form.cabecera.numero_identificacion = comprobante.ruc;
      this.form.cabecera.tipo_documento = comprobante.tipo_documento;
      this.form.cabecera.id_moneda = comprobante.moneda;
      if (comprobante.persona != null) {
        this.decimales_compras = comprobante.persona.decimales_compras;
      }
      else 
        this.decimales_compras = 2;
      if (this.tipoComprobanteConsulta === this.tipoComprobante) {
        this.anulado = comprobante.estado === "A" ? "N" : "S";
        this.form.cabecera.mybillbot = comprobante.tipo === "R";
        this.form.formasPago = [];
        this.form.cabecera.fecha_emision = moment(
          new Date(comprobante.fecha_emision)
        ).format("YYYY-MM-DD");
        this.form.cabecera.fecha_autorizacion = moment(
          new Date(comprobante.fecha_autorizacion)
        ).format("YYYY-MM-DD HH:mm");
        this.form.cabecera.numero_autorizacion =
          comprobante.numero_autorizacion;
        this.form.cabecera.numero_documento = comprobante.numero;
        this.form.cabecera.clave_acceso = comprobante.clave_acceso;
        for (let i = 0; i < comprobante.formas_pago.length; i++)
          this.form.formasPago.push({
            selectedFormaPago: comprobante.formas_pago[i].forma_pago,
            valor: comprobante.formas_pago[i].total,
            plazo: comprobante.formas_pago[i].plazo,
            unidad_tiempo: comprobante.formas_pago[i].unidad_tiempo,
          });
        this.form.informacionAdicional = [];
        for (let i = 0; i < comprobante.informacion_adicional.length; i++)
          this.form.informacionAdicional.push({
            nombre_campo: comprobante.informacion_adicional[i].nombre,
            valor_campo: comprobante.informacion_adicional[i].valor,
          });
        this.form.tipo_comprobante = this.tipoComprobante;
        this.form.cabecera.estado = comprobante.estado;
        this.id_comprobante = comprobante.id_comprobante;
        if (comprobante.path_foto != null)
          this.path_foto = url + '/storage/' + comprobante.path_foto;
        else 
          this.path_foto = '';
        this.form.cabecera.tipo_comprobante_afectado =
          comprobante.cod_comp_venta;
        this.form.cabecera.numero_comprobante_afectado =
          comprobante.num_comp_venta;
        this.form.cabecera.fecha_emision_comprobante_afectado =
          comprobante.fec_emi_comp_venta !== null
            ? moment(new Date(comprobante.fec_emi_comp_venta)).format(
                "YYYY-MM-DD"
              )
            : "";
        this.form.cabecera.tipo =
          comprobante.es_electronica === "S" ? "E" : "M";
      } else {
        this.form.cabecera.tipo_comprobante_afectado =
          comprobante.codigo_documento;
        this.form.cabecera.numero_comprobante_afectado = comprobante.numero;
        this.form.cabecera.fecha_emision_comprobante_afectado = moment(
          new Date(comprobante.fecha_emision)
        ).format("YYYY-MM-DD");
      }
      for (let i = 0; i < comprobante.items.length; i++) {
        let item = {
          cantidad: comprobante.items[i].cantidad,
          precio: comprobante.items[i].precio_unitario,
          nombre_item: comprobante.items[i].descripcion,
          total_descuento: comprobante.items[i].descuento,
          total_parcial: comprobante.items[i].precio_sin_imp,
          id_item: comprobante.items[i].codigo_principal,
          total_impuestos: 0,
          total: parseFloat(comprobante.items[i].precio_sin_imp),
          precio_produccion: comprobante.items[i].item.precio_produccion,
          irbpnr: comprobante.items[i].item.irbpnr === "S",
          total_irbpnr: 0,
          cantidad_ice: comprobante.items[i].item.cantidad_ice,
          cantidad_irbpnr: comprobante.items[i].item.cantidad_irbpnr,
          ice: 0,
          id_ice: "",
          detalle: "",
        };
        if (item.irbpnr)
          item.total_irbpnr =
            parseFloat(this.irbpnr) * parseFloat(item.cantidad);
        if (isNaN(item.total_irbpnr)) item.total_irbpnr = 0;
        for (let j = 0; j < comprobante.items[i].impuestos.length; j++) {
          if (comprobante.items[i].impuestos[j].codigo === this.codigoIva) {
            item.id_iva = comprobante.items[i].impuestos[j].codigo_porcentaje;
            item.iva = comprobante.items[i].impuestos[j].valor;
            item.porcentaje_iva = comprobante.items[i].impuestos[j].tarifa;
          } else if (
            comprobante.items[i].impuestos[j].codigo === this.codigoIce
          ) {
            item.id_ice = comprobante.items[i].impuestos[j].codigo_porcentaje;
            item.ice = comprobante.items[i].impuestos[j].valor;
            item.porcentaje_ice = comprobante.items[i].impuestos[j].tarifa;
            item.numero_unidades_ice =
              comprobante.items[i].item.numero_unidades_ice;
            item.tarifa_especifica_ice =
              comprobante.items[i].item.tarifa_especifica;
            item.porcentaje_ed_valorem =
              comprobante.items[i].item.porcentaje_ed_valorem;
          }
          let iva = parseFloat(item.iva);
          let ice = parseFloat(item.ice);
          item.total_impuestos +=
            (isNaN(iva) ? 0 : iva) + (isNaN(ice) ? 0 : ice) + item.total_irbpnr;
        }
        item.total += parseFloat(item.total_impuestos);
        this.form.items.push(item);
      }
    },
    anularComprobante: function () {
      let that = this;
      swal({
        title: "¿Desea anular este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular comprobante",
        cancelButtonText: "No",
      }).then(function (result) {
        if (result.value) {
          axios
            .post(that.url + "/compras/" + that.id_comprobante, {
              _method: "DELETE",
            })
            .then(function (response) {
              that.anulado = "S";
              swal("El comprobante ha sido anulado.", "Anulado", "success");
            });
        }
      });
    },
    nuevoComprobante: function () {
      let that = this;
      swal({
        title: "¿Desear crear un nuevo comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nuevo comprobante",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          that.path_foto = '';
          that.form = {
            cabecera: {
              clave_acceso: "",
              numero_autorizacion: "",
              numero_documento: "",
              fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
              id_proveedor: "",
              id_moneda: "",
              fecha_autorizacion: "",
              mybillbot: false,
              tipo_documento: "",
              tipo: "E",
              numero_identificacion: "",
              estado: "N",
              tipo_comprobante: this.tipoComprobante,
              tipo_comprobante_afectado: "",
              numero_comprobante_afectado: "",
              fecha_emision_comprobante_afectado: "",
            },
            items: [],
            formasPago: [],
            informacionAdicional: [],
            total_sin_impuestos: 0,
            descuento_total: 0,
            subtotal_no_sujeto_iva: 0,
            subtotal_exento_iva: 0,
            total_irbpnr: 0,
            iva: 0,
            subtotal_iva: 0,
            subtotal_iva_0: 0,
            ice: 0,
            total: 0,
            _method: undefined,
          };
          that.id_comprobante = "";
          that.anulado = "N";
          that.form.cabecera.estado = "N";
        }
      });
    },
  },
  mounted: function () {
    this.cargarDatosFormulario();
  },
  computed: {
    editable: function () {
      let editable = true;
      if (this.anulado === "S" || this.form.cabecera.mybillbot)
        editable = false;
      return editable;
    },
    permiteCrearComprobante: function () {
      let crearComprobante = false;
      if (this.tipoComprobante === this.codigoFactura)
        crearComprobante = this.permiteCrearCompra;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        crearComprobante = this.permiteCrearNc;
      return crearComprobante;
    },
    permiteEditarComprobante: function () {
      let editarComprobante = false;
      if (this.tipoComprobante === this.codigoFactura)
        editarComprobante = this.permiteEditarCompra;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        editarComprobante = this.permiteEditarNc;
      return editarComprobante;
    },
    permiteAnularComprobante: function () {
      let anularCompra = false;
      if (this.tipoComprobante === this.codigoFactura)
        anularCompra = this.permiteAnularCompra;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        anularCompra = this.permiteAnularNc;
      return anularCompra;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/compras/ComprobanteCompra.vue